<template>
  <div>
    <v-list-item-action class="align-center">
      <v-chip class="text-center mt-5 headline" label :color="engagementClass">{{engagementLabel}}</v-chip>
      <v-list-item-action-text class="align-self-center">Engagement</v-list-item-action-text>
    </v-list-item-action>
    <v-list-item-action class="align-center ml-3">
      <span class="text-center mx-auto headline mt-5" :class="activityClass">{{ activityLabel }}</span>
      <v-list-item-action-text class="mx-auto">Activity</v-list-item-action-text>
    </v-list-item-action>
    <v-list-item-action class="align-center ml-3">
      <span class="text-center mx-auto headline mt-5" :class="profileClass">{{ profileLabel }}</span>
      <v-list-item-action-text>Profile</v-list-item-action-text>
    </v-list-item-action>
    <v-list-item-action class="align-center ml-3" v-if="showJobOffers">
      <edit-profile class="mt-5" :profile-id="profile._id" :IdTarget="'salary'" v-if="!salaryProvided">
        <v-btn small class="primary">
          <v-icon left small>
            mdi-pencil
          </v-icon>
          Add salary
        </v-btn>
      </edit-profile>
      <span v-else-if="profile.edges.engagement.market === null" class="primary--text text-center mx-auto headline mt-5">
        Computing...
      </span>
      <span class="text-center mx-auto headline mt-5" :class="marketClass" v-else>{{ marketLabel }}</span>
      <v-list-item-action-text>Market</v-list-item-action-text>
    </v-list-item-action>
  </div>
</template>

<script>
    import EditProfile from "../Buttons/Profiles/editProfile";
    import {mapEngagementColor} from "../../helpers/helpers";
    export default {
        name: "profileHeadingScoresStaff",
        components: {EditProfile},
      props: ['profile', 'showJobOffers'],
      computed: {
        engagementClassText(){
          return `${this.engagementClass}--text`;
        },
        engagementLabel(){
          return this.profile.edges && this.profile.edges.engagement ? this.profile.edges.engagement.total.label : 'NOT PROCESSED';
        },
        engagementClass(){
          return mapEngagementColor(this.profile.edges.engagement.total.value);
        },
        activityLabel(){
          return this.profile.edges && this.profile.edges.engagement ? this.profile.edges.engagement.activity.label : 'NOT PROCESSED';
        },
        activityClass(){
          return mapEngagementColor(this.profile.edges.engagement.activity.value)+'--text';
        },
        profileLabel(){
          return this.profile.edges && this.profile.edges.engagement ? this.profile.edges.engagement.profile.label : 'NOT PROCESSED';
        },
        profileClass(){
          return mapEngagementColor(this.profile.edges.engagement.profile.value)+'--text';
        },
        engagementValue(){
          return this.profile.edges.market.engagementWeightsLabels[0].value;
        },
        marketClass(){
          return mapEngagementColor(this.profile.edges.engagement.market.value)+'--text';
        },
        marketLabel(){
          return this.profile.edges && this.profile.edges.engagement ? this.profile.edges.engagement.market.label : 'NOT PROCESSED';
        },
        salaryProvided() {
          return this.profile && this.profile.salary && this.profile.salary.length > 0 && this.profile.salary[0].baseSalaryRange &&
            (this.profile.salary[0].baseSalaryRange.max > 0 || (this.profile.salary[0].baseSalaryRange.max === null && this.profile.salary[0].baseSalaryRange.min > 0));
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Widgets/profileHeadingScoresStaff.vue